/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Feed ausklappen */
document.addEventListener('DOMContentLoaded', function () {
    const cards = Array.from(document.querySelectorAll('.z2-feed-card'));

    function collapseCard(card) {
        if (!card.classList.contains('is-expanded')) return;
        card.classList.remove('is-expanded');
        const btn = card.querySelector('.z2-feed-toggle');
        if (btn) {
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = 'Mehr anzeigen';
        }
    }

    function expandCard(card, btn) {
        // andere Cards zuklappen
        cards.forEach(other => {
            if (other !== card) {
                collapseCard(other);
            }
        });
        // diese Card togglen
        const willExpand = !card.classList.contains('is-expanded');
        if (willExpand) {
            card.classList.add('is-expanded');
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = 'Weniger anzeigen';
        } else {
            collapseCard(card);
        }
    }

    // 2) Klick-Handling: Toggle + Außenklick
    document.addEventListener('click', function (event) {
        const toggle = event.target.closest('.z2-feed-toggle');

        if (toggle) {
            const card = toggle.closest('.z2-feed-card');
            if (!card) return;
            expandCard(card, toggle);
            return;
        }

        // Klick außerhalb aller Cards -> alle einklappen
        if (!event.target.closest('.z2-feed-card')) {
            cards.forEach(collapseCard);
        }
    });
});

/* Auto-Refresh Feed */
document.addEventListener("DOMContentLoaded", function () {
    const checkbox = document.getElementById("z2-feed-refresh-toggle");

    const STORAGE_KEY = "z2-feed-auto-refresh-enabled";
    const REFRESH_SECONDS = 60;
    const RSS_URL = "/tag/z2-feed/rss/";

    let refreshInterval = null;
    let initialPubDate = null;

    async function getLatestPubDate() {
        try {
            const response = await fetch(RSS_URL, {
                cache: "no-cache"
            });
            if (!response.ok) {
                console.warn("RSS-Fehler:", response.status);
                return null;
            }

            const xmlText = await response.text();
            const parser = new DOMParser();
            const xml = parser.parseFromString(xmlText, "application/xml");

            // pubDate oder dc:date
            const pubDateEl =
                xml.querySelector("channel > item > pubDate") ||
                xml.querySelector("channel > item > dc\\:date");

            if (!pubDateEl) return null;

            const dateStr = pubDateEl.textContent.trim();
            const timestamp = new Date(dateStr).getTime();

            return isNaN(timestamp) ? null : timestamp;

        } catch (err) {
            console.error("RSS-Fehler:", err);
            return null;
        }
    }

    async function checkForNewPosts() {
        const latest = await getLatestPubDate();
        if (!latest) return;

        // Initialen Zustand merken
        if (!initialPubDate) {
            initialPubDate = latest;
            return;
        }

        // neuer Beitrag?
        if (latest > initialPubDate) {
            console.log("Neue Beiträge (pubDate) erkannt → Reload");
            window.location.reload();
        }
    }

    function startAutoRefresh() {
        if (refreshInterval) return;
        checkForNewPosts(); // einmal direkt
        refreshInterval = setInterval(checkForNewPosts, REFRESH_SECONDS * 1000);
    }

    function stopAutoRefresh() {
        if (!refreshInterval) return;
        clearInterval(refreshInterval);
        refreshInterval = null;
    }

    // Zustand aus localStorage einlesen
    if (checkbox) {
        const saved = localStorage.getItem(STORAGE_KEY);
        const enabled = saved === "1";

        if (enabled) {
            checkbox.checked = true;
            startAutoRefresh();
        }

        checkbox.addEventListener("change", function () {
            const active = checkbox.checked;
            if (active) {
                startAutoRefresh();
                localStorage.setItem(STORAGE_KEY, "1");
            } else {
                stopAutoRefresh();
                localStorage.setItem(STORAGE_KEY, "0");
            }
        });
    }
});

